import { StyleSheet } from "react-native";
import { theme } from "../../theme";
const linkColorCombinations = {
    brand: {
        text: "base",
        hover: "dark",
    },
    accent: {
        text: "base",
        hover: "dark",
    },
    usp: {
        text: "base",
        hover: "dark",
    },
    warning: {
        text: "base",
        hover: "dark",
    },
    negative: {
        text: "base",
        hover: "dark",
    },
    greyscale: {
        text: "base",
        hover: "dark",
    },
    light: {
        text: "base",
        hover: "base",
    },
    positive: {
        text: "base",
        hover: "base",
    },
};
export const styles = StyleSheet.create({
    container: {
        alignItems: "center",
    },
    underline: {
        borderBottomWidth: 2,
    },
    linkText: {
        ...theme.fontDefaults.base,
        fontWeight: "600",
    },
});
export const colorStyles = StyleSheet.create({
    ...Object.assign({}, ...Object.entries(linkColorCombinations).map((input) => {
        // Casting required due to limited inference on Object.entries()
        const [accessor, colors] = input;
        return {
            [accessor]: {
                position: "relative",
                color: theme.colors[accessor][colors.text],
            },
        };
    })),
});
export const borderColorStyles = StyleSheet.create({
    ...Object.assign({}, ...Object.entries(linkColorCombinations).map((input) => {
        // Casting required due to limited inference on Object.entries()
        const [accessor, colors] = input;
        return {
            [accessor]: {
                borderBottomColor: theme.colors[accessor][colors.text],
            },
        };
    })),
});
//# sourceMappingURL=Link.styles.js.map